const routes = [
  {
    path: "",
    redirect: "/prefabricateReport",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login/index.vue"),
  },
  {
    path: "/diyReport",
    name: "diyReport",
    component: (resolve) => require(["@/views/router_page.vue"], resolve),
    meta: {
      hasLeft: false,
    },
    children: [
      {
        path: "",
        component: () => import("@/views/diyReport/index.vue"),
      },
    ],
  },
  {
    path: "/prefabricateReport",
    name: "prefabricateReport",
    component: (resolve) => require(["@/views/router_page.vue"], resolve),
    meta: {
      hasLeft: true,
    },
    redirect: "/prefabricateReport/emptyPage/emptyPage",
    children: [
      // 定制报表
      {
        path: "emptyPage",
        name: "emptyPage",
        redirect: "/prefabricateReport/emptyPage/emptyPage",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          {
            path: "emptyPage",
            name: "emptyPage",
            component: (resolve) => require(["@/views/prefabricateReport/emptyPage/index.vue"], resolve),
            meta: {
              hasLeft: true,
            },
          },
        ],
      },
      // 定制报表
      {
        path: "customizeAnalysis",
        name: "customizeAnalysis",
        redirect: "/prefabricateReport/customizeAnalysis/customizeAnalysis",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          {
            path: "customizeAnalysis",
            name: "customizeAnalysis",
            component: (resolve) => require(["@/views/diyReport/index.vue"], resolve),
            meta: {
              hasLeft: true,
            },
          },
        ],
      },
      // 常用报表
      {
        path: "markAnalysis",
        name: "markAnalysis",
        redirect: "/prefabricateReport/markAnalysis/markAnalysis",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          {
            path: "",
            name: "markAnalysis",
            component: (resolve) => require(["@/views/prefabricateReport/emptyPage/index.vue"], resolve),
            meta: {
              hasLeft: true,
            },
          },
        ],
      },
      // 店铺分析
      {
        path: "marketAnalysis",
        redirect: "/prefabricateReport/marketAnalysis/region_analysis",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          // 地域分布分析
          {
            path: "region_analysis",
            name: "region_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/marketAnalysis/region_distribution_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
              title: "地域销售总览",
            },
          },
          // 线级城市分析
          {
            path: "tiercity_analysis",
            name: "tiercity_analysis",
            component: (resolve) => {
              require(["@/views/prefabricateReport/marketAnalysis/tiercity_analysis.vue"], resolve);
            },
            meta: {
              hasLeft: true,
              title: "线级城市分析",
            },
          },
          // 交易类型销售分析
          {
            path: "transtype_analysis",
            name: "transtype_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/marketAnalysis/transtype_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
          // 新老客销售分析
          {
            path: "customersales_analysis",
            name: "customersales_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/marketAnalysis/customersales_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },

          // 店铺销售分析
          {
            path: "marketsales_analysis",
            name: "marketsales_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/marketAnalysis/marketsales_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
          // 平台销售分析
          {
            path: "platform_analysis",
            name: "platform_analysis",
            component: (resolve) => {
              require(["@/views/prefabricateReport/marketAnalysis/platform_analysis.vue"], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
        ],
      },
      // 客户分析
      {
        path: "customerAnalysis",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        redirect: "/prefabricateReport/customerAnalysis/perchaseamount_analysis",
        children: [
          // 购买金额分析
          {
            path: "perchaseamount_analysis",
            name: "perchaseamount_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/customerAnalysis/perchaseamount_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
          // 购买次数分析
          {
            path: "perchasetimes_analysis",
            name: "perchasetimes_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/customerAnalysis/perchasetimes_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
          // 购买件数分析
          {
            path: "perchasenumber_analysis",
            name: "perchasenumber_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/customerAnalysis/perchasenumber_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
          // 客户复购周期分析
          {
            path: "recustomercycle_analysis",
            name: "recustomercycle_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/customerAnalysis/recustomercycle_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
          // 客户复购率分析
          {
            path: "recustomerrate_analysis",
            name: "recustomerrate_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/customerAnalysis/recustomerrate_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
          // 客户回购分析
          {
            path: "recustomer_analysis",
            name: "recustomer_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/customerAnalysis/recustomer_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
          // 新老客（年报）
          {
            path: "customer_analysis",
            name: "customer_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/customerAnalysis/newAndOld_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
          // 新老客（月报）
          {
            path: "hiscustomer_analysis",
            name: "hiscustomer_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/customerAnalysis/history_newAndOld_analysis.vue",
              ], resolve);
            },
            meta: {
              hasLeft: true,
            },
          },
        ],
      },
      // 会员分析
      {
        path: "memberAnalysis",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        redirect: "/prefabricateReport/memberAnalysis/platform_card_analysis",
        children: [
          // 平台开卡分析
          {
            path: "platform_card_analysis",
            name: "platform_card_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/memberAnalysis/platform_card_analysis.vue",
              ], resolve);
            },
            meta: {
              title: "平台开卡分析",
              hasLeft: true,
            },
          },
          // 会员（年报）
          {
            path: "member_year_analysis",
            name: "member_year_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/memberAnalysis/member_year_analysis.vue",
              ], resolve);
            },
            meta: {
              title: "会员（年报）",
              hasLeft: true,
            },
          },
          // 会员（月报）
          {
            path: "hispurch_analysis",
            name: "hispurch_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/memberAnalysis/member_month_analysis.vue",
              ], resolve);
            },
            meta: {
              title: "会员（月报）",
              hasLeft: true,
            },
          },
        ],
      },
      // 专项分析
      {
        path: "specialAnalysis",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          // 订单优惠分析（淘宝）
          {
            path: "preferential_analysis",
            name: "preferential_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/specialAnalysis/preferential_analysis.vue",
              ], resolve);
            },
            meta: {
              title: "订单优惠分析（淘宝）",
              hasLeft: true,
            },
          },
          // 购物金订单分析（淘宝）
          {
            path: "shopping_cost_analysis",
            name: "shopping_cost_analysis",
            component: (resolve) => {
              require([
                "@/views/prefabricateReport/specialAnalysis/shopping_cost_analysis.vue",
              ], resolve);
            },
            meta: {
              title: "购物金订单分析（淘宝）",
              hasLeft: true,
            },
          },
          // 订单来源分析（抖音）
          {
            path: "stream_analysis",
            name: "stream_analysis",
            component: (resolve) => {
              require(["@/views/prefabricateReport/specialAnalysis/stream_analysis.vue"], resolve);
            },
            meta: {
              title: "订单来源分析（抖音）",
              hasLeft: true,
            },
          },
        ],
      },
      // 复盘报表
      {
        path: "reviewReport",
        name: "reviewReport",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          // 空白页
          {
            path: "",
            name: "",
            component: (resolve) => require(["@/views/prefabricateReport/emptyPage/index.vue"], resolve),
            meta: {
              title: "",
              hasLeft: true,
            },
          },
          // 销售分析
          {
            path: "salesAnalysis",
            name: "salesAnalysis",
            component: (resolve) => require(["@/views/prefabricateReport/reviewReport/index.vue"], resolve),
            children: [
              // 销售概览
              {
                path: "salesAnalysisQuery",
                name: "salesAnalysisQuery",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/salesAnalysis/salesAnalysisQuery.vue",
                  ], resolve);
                },
                meta: {
                  title: "销售概览",
                  hasLeft: true,
                },
              },
              // 地域销售
              {
                path: "regionSalesAnalysis",
                name: "regionSalesAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/index.vue",
                  ], resolve);
                },
                children: [
                  // 商品标签地域明细
                  {
                    path: "regional_details",
                    name: "regional_details",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/regionSalesAnalysis/regionalDetails.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "商品标签地域明细",
                      hasLeft: true,
                    },
                  },
                  // 地域下钻商品标签
                  {
                    path: "regional_drill",
                    name: "regional_drill",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/regionSalesAnalysis/regionalDrill.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "地域下钻商品标签",
                      hasLeft: true,
                    },
                  },
                ],
                meta: {
                  title: "地域销售",
                  hasLeft: true,
                },
              },
              // 商品销售
              {
                path: "marketAnalysis",
                name: "marketAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/index.vue",
                  ], resolve);
                },
                children: [
                  // 商品sku销售
                  {
                    path: "marketAnalysisSku",
                    name: "marketAnalysisSku",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "商品sku销售",
                      hasLeft: true,
                      type:'sku'
                    },
                  },
                  // 商品spu销售
                  {
                    path: "marketAnalysisSpu",
                    name: "marketAnalysisSpu",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue", 
                      ], resolve);
                    },
                    meta: {
                      title: "商品spu销售",
                      hasLeft: true,
                      type:'spu'
                    },
                  },
                  // 平台类目销售
                  {
                    path: "marketCategory",
                    name: "marketCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "平台类目销售",
                      hasLeft: true,
                      type:'category'
                    },
                  },
                  // 店铺类目销售
                  {
                    path: "marketSellerCategory",
                    name: "marketSellerCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "店铺类目销售",
                      hasLeft: true,
                      type:'sellerCategory'
                    },
                  },
                  // 自定义类目销售
                  {
                    path: "marketCustomCategory",
                    name: "marketCustomCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "自定义类目销售",
                      hasLeft: true,
                      type:'customCategory'
                    },
                  },
                  // 商品标签销售
                  {
                    path: "marketItemTag",
                    name: "marketItemTag",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "商品标签销售",
                      hasLeft: true,
                      type:'itemTag'
                    },
                  },
                ],
                meta: {
                  title: "商品销售",
                  hasLeft: true,
                },
              },
              // 抖音分析
              {
                path: "dyLiveAnalysis",
                name: "dyLiveAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/index.vue",
                ], resolve);
                },
                children: [
                  // 下单来源
                  {
                    path: "themeTypeAnalysis",
                    name: "themeTypeAnalysis",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/dyLiveAnalysis/orderAndTrafficSource.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "下单来源",
                      hasLeft: true,
                    },
                  },
                  // 流量来源
                  {
                    path: "cBizAnalysis",
                    name: "cBizAnalysis",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/dyLiveAnalysis/orderAndTrafficSource.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "流量来源",
                      hasLeft: true,
                    },
                  },
                  // 直播间交易
                  {
                    path: "roomTradeAnalysis",
                    name: "roomTradeAnalysis",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/dyLiveAnalysis/liveAndVideoSource.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "直播间交易",
                      hasLeft: true,
                    },
                  },
                  // 短视频交易
                  {
                    path: "videoTradeAnalysis",
                    name: "videoTradeAnalysis",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/dyLiveAnalysis/liveAndVideoSource.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "短视频交易",
                      hasLeft: true,
                    },
                  },
                  // 主播交易
                  {
                    path: "authorTradeAnalysis",
                    name: "authorTradeAnalysis",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/salesAnalysis/dyLiveAnalysis/anchorTrading.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "主播交易",
                      hasLeft: true,
                    },
                  },
                ],
                meta: {
                  title: "抖音分析",
                  hasLeft: true,
                },
              },
            ],
            meta: {
              title: "销售分析",
              hasLeft: true,
            },
          },
          // 会员分析
          {
            path: "memberAnalysis",
            name: "memberAnalysis",
             component: (resolve) => require(["@/views/prefabricateReport/reviewReport/index.vue"], resolve),
            children: [
              // 会员概况
              {
                path: "memberOverviewAnalysis",
                name: "memberOverviewAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/memberOverviewAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员概况",
                  hasLeft: true,
                },
              },
              // 会员招募-京东
              {
                path: "jdMembershipRecruitment",
                name: "jdMembershipRecruitment",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/jdMembershipRecruitment.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员招募（京东）",
                  hasLeft: true,
                },
              },
              // 会员招募-淘宝
              {
                path: "tbMembershipRecruitment",
                name: "tbMembershipRecruitment",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/tbMembershipRecruitment.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员招募（淘宝）",
                  hasLeft: true,
                },
              },
              // 会员等级分析
              {
                path: "memberLevelAnalysis",
                name: "memberLevelAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/memberLevelAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员等级分析",
                  hasLeft: true,
                },
              },
               // 会员等级分析(会员通)
               {
                path: "memberLevelHytAnalysis",
                name: "memberLevelHytAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/memberLevelHytAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员等级分析（会员通）",
                  hasLeft: true,
                },
              },
              // 会员地域销售
              {
                path: "memberGradeAreaAnalysis",
                name: "memberGradeAreaAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/memberGradeAreaAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员地域销售",
                  hasLeft: true,
                },
              },
              // 会员积分分析
              {
                path: "memberPointsAnalysis",
                name: "memberPointsAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/memberPointsAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员积分分析",
                  hasLeft: true,
                },
              },
              // 积分变更分析
              {
                path: "pointsChangeAnalysis",
                name: "pointsChangeAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/pointsChangeAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "积分变更分析",
                  hasLeft: true,
                },
              },
              // 会员生命周期
              {
                path: "memberLifecycle",
                name: "memberLifecycle",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/memberLifecycle.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员生命周期",
                  hasLeft: true,
                },
              },
              // 会员等级件单价
              {
                path: "rankItemPrice",
                name: "rankItemPrice",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/rankItemPrice.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员等级件单价",
                  hasLeft: true,
                },
              },
              // 会员等级购买金额
              {
                path: "rankPurchaseAmount",
                name: "rankPurchaseAmount",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/rankPurchaseAmount.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员等级购买金额",
                  hasLeft: true,
                },
              },
              // 会员等级购买频次
              {
                path: "rankPurchaseCount",
                name: "rankPurchaseCount",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/rankPurchaseCount.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员等级购买频次",
                  hasLeft: true,
                },
              },
              // 会员等级客单价
              {
                path: "rankPurchasePrice",
                name: "rankPurchasePrice",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/rankPurchasePrice.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员等级客单价",
                  hasLeft: true,
                },
              },
              // 会员等级复购周期
              {
                path: "rankPurchaseCycle",
                name: "rankPurchaseCycle",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/memberAnalysis/rankPurchaseCycle.vue",
                  ], resolve);
                },
                meta: {
                  title: "会员等级复购周期",
                  hasLeft: true,
                },
              },
            ],
            meta: {
              title: "会员分析",
              hasLeft: true,
            },
          },
          // 关联分析
          {
            path: "associationAnalysis",
            name: "associationAnalysis",
             component: (resolve) => require(["@/views/prefabricateReport/reviewReport/index.vue"], resolve),
            children: [
              // 同比关联
              {
                path: "sameCountAssociation",
                name: "sameCountAssociation",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/index.vue",
                  ], resolve);
                },
                children: [
                  // 同笔关联-商品sku
                  {
                    path: "sameCountSku",
                    name: "sameCountSku",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同笔关联-商品sku",
                      hasLeft: true,
                      type: "sku",
                    },
                  },
                  // 同笔关联-商品spu
                  {
                    path: "sameCountSpu",
                    name: "sameCountSpu",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同笔关联-商品spu",
                      hasLeft: true,
                      type: "spu",
                    },
                  },
                  // 同笔关联-平台类目
                  {
                    path: "sameCountCategory",
                    name: "sameCountCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同笔关联-平台类目",
                      hasLeft: true,
                      type: "category",
                    },
                  },
                  // 同笔关联-店铺类目
                  {
                    path: "sameCountSellerCategory",
                    name: "sameCountSellerCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同笔关联-店铺类目",
                      hasLeft: true,
                      type: "sellerCategory",
                    },
                  },
                  // 同笔关联-商品标签
                  {
                    path: "sameCountItemTag",
                    name: "sameCountItemTag",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同笔关联-商品标签",
                      hasLeft: true,
                      type: "itemTag",
                    },
                  },
                ],
                meta: {
                  title: "同比关联",
                  hasLeft: true,
                },
              },
              // 复购关联
              {
                path: "repurchaseAssociation",
                name: "repurchaseAssociation",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/index.vue",
                  ], resolve);
                },
                children: [
                  // 复购关联-商品sku
                  {
                    path: "repurchaseSku",
                    name: "repurchaseSku",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "复购关联-商品sku",
                      hasLeft: true,
                      type: "sku",
                    },
                  },
                  // 复购关联-商品spu
                  {
                    path: "repurchaseSpu",
                    name: "repurchaseSpu",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "复购关联-商品spu",
                      hasLeft: true,
                      type: "spu",
                    },
                  },
                  // 复购关联-平台类目
                  {
                    path: "repurchaseCategory",
                    name: "repurchaseCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "复购关联-平台类目",
                      hasLeft: true,
                      type: "category",
                    },
                  },
                  // 复购关联-店铺类目
                  {
                    path: "repurchaseSellerCategory",
                    name: "repurchaseSellerCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "复购关联-店铺类目",
                      hasLeft: true,
                      type: "sellerCategory",
                    },
                  },
                  // 复购关联-商品标签
                  {
                    path: "repurchaseItemTag",
                    name: "repurchaseItemTag",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "复购关联-商品标签",
                      hasLeft: true,
                      type: "itemTag",
                    },
                  },
                ],
                meta: {
                  title: "同比关联",
                  hasLeft: true,
                },
              },
              // 交叉关联
              {
                path: "intersectionAssociation",
                name: "intersectionAssociation",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/index.vue",
                  ], resolve);
                },
                children: [
                  // 交叉关联-商品sku
                  {
                    path: "intersectionSku",
                    name: "intersectionSku",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "交叉关联-商品sku",
                      hasLeft: true,
                      type: "sku",
                    },
                  },
                  // 交叉关联-商品spu
                  {
                    path: "intersectionSpu",
                    name: "intersectionSpu",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "交叉关联-商品spu",
                      hasLeft: true,
                      type: "spu",
                    },
                  },
                  // 交叉关联-平台类目
                  {
                    path: "intersectionCategory",
                    name: "intersectionCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "交叉关联-平台类目",
                      hasLeft: true,
                      type: "category",
                    },
                  },
                  // 交叉关联-店铺类目
                  {
                    path: "intersectionSellerCategory",
                    name: "intersectionSellerCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "交叉关联-店铺类目",
                      hasLeft: true,
                      type: "sellerCategory",
                    },
                  },
                  // 交叉关联-商品标签
                  {
                    path: "intersectionItemTag",
                    name: "intersectionItemTag",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "交叉关联-商品标签",
                      hasLeft: true,
                      type: "itemTag",
                    },
                  },
                ],
                meta: {
                  title: "交叉关联",
                  hasLeft: true,
                },
              },
              // 售前关联
              {
                path: "presalesAssociation",
                name: "presalesAssociation",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/index.vue",
                  ], resolve);
                },
                children: [
                  // 售前关联-商品sku
                  {
                    path: "presalesSku",
                    name: "presalesSku",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "售前关联-商品sku",
                      hasLeft: true,
                      type: "sku",
                    },
                  },
                  // 售前关联-商品spu
                  {
                    path: "presalesSpu",
                    name: "presalesSpu",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "售前关联-商品spu",
                      hasLeft: true,
                      type: "spu",
                    },
                  },
                  // 售前关联-平台类目
                  {
                    path: "presalesCategory",
                    name: "presalesCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "售前关联-平台类目",
                      hasLeft: true,
                      type: "category",
                    },
                  },
                  // 售前关联-店铺类目
                  {
                    path: "presalesSellerCategory",
                    name: "presalesSellerCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "售前关联-店铺类目",
                      hasLeft: true,
                      type: "sellerCategory",
                    },
                  },
                  // 售前关联-商品标签
                  {
                    path: "presalesItemTag",
                    name: "presalesItemTag",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "售前关联-商品标签",
                      hasLeft: true,
                      type: "itemTag",
                    },
                  },
                ],
                meta: {
                  title: "售前关联",
                  hasLeft: true,
                },
              },
            ],
            meta: {
              title: "关联分析",
              hasLeft: true,
            },
          },
          // 复购分析
          {
            path: "buyAgainAnalysis",
            name: "buyAgainAnalysis",
             component: (resolve) => require(["@/views/prefabricateReport/reviewReport/index.vue"], resolve),
            children: [
              // 同品复购
              {
                path: "sameProduct",
                name: "sameProduct",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/index.vue",
                  ], resolve);
                },
                children: [
                  // 同品复购-商品sku
                  {
                    path: "sameProductSku",
                    name: "sameProductSku",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同品复购-商品sku",
                      hasLeft: true,
                      type: "sku",
                    },
                  },
                  // 同品复购-商品spu
                  {
                    path: "sameProductSpu",
                    name: "sameProductSpu",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同品复购-商品spu",
                      hasLeft: true,
                      type: "spu",
                    },
                  },
                  // 同品复购-平台类目
                  {
                    path: "sameProductCategory",
                    name: "sameProductCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同品复购-平台类目",
                      hasLeft: true,
                      type: "category",
                    },
                  },
                  // 同品复购-店铺类目
                  {
                    path: "sameProductSellerCategory",
                    name: "sameProductSellerCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同品复购-店铺类目",
                      hasLeft: true,
                      type: "sellerCategory",
                    },
                  },
                  // 同品复购-店铺类目
                  {
                    path: "sameProductItemTag",
                    name: "sameProductItemTag",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "同品复购-商品标签",
                      hasLeft: true,
                      type: "itemTag",
                    },
                  },
                ],
                meta: {
                  title: "同品复购",
                  hasLeft: true,
                },
              },
              // 商品购买-店铺复购
              {
                path: "repurchaseStoreProduct",
                name: "repurchaseStoreProduct",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/index.vue",
                  ], resolve);
                },
                children: [
                  // 商品sku购买-店铺复购
                  {
                    path: "storeProductSku",
                    name: "storeProductSku",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "商品sku购买-店铺复购",
                      hasLeft: true,
                      type: "sku",
                    },
                  },
                  // 商品spu购买-店铺复购
                  {
                    path: "storeProductSpu",
                    name: "storeProductSpu",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "商品spu购买-店铺复购",
                      hasLeft: true,
                      type: "spu",
                    },
                  },
                  // 平台类目购买-店铺复购
                  {
                    path: "storeProductCategory",
                    name: "storeProductCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "平台类目购买-店铺复购",
                      hasLeft: true,
                      type: "category",
                    },
                  },
                  // 店铺类目购买-店铺复购
                  {
                    path: "storeProductSellerCategory",
                    name: "storeProductSellerCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "店铺类目购买-店铺复购",
                      hasLeft: true,
                      type: "sellerCategory",
                    },
                  },
                  // 店铺标签购买-店铺复购
                  {
                    path: "storeProductItemTag",
                    name: "storeProductItemTag",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "店铺标签购买-店铺复购",
                      hasLeft: true,
                      type: "itemTag",
                    },
                  },
                ],
                meta: {
                  title: "商品购买-店铺复购",
                  hasLeft: true,
                },
              },
            ],
            meta: {
              title: "关联分析",
              hasLeft: true,
            },
          },
          //  客户分析
          {
            path: "customerAnalysis",
            name: "customerAnalysis",
             component: (resolve) => require(["@/views/prefabricateReport/reviewReport/index.vue"], resolve),
            children: [
              // 留存率分析
              // {
              //   path: "retentionRateAnalysis",
              //   name: "retentionRateAnalysis",
              //   component: (resolve) => {
              //     require([
              //       "@/views/prefabricateReport/reviewReport/customerAnalysis/retentionRateAnalysis.vue",
              //     ], resolve);
              //   },
              //   meta: {
              //     title: "留存率分析",
              //     hasLeft: true,
              //   },
              // },
              // 生命周期分析
              {
                path: "lifecycleAnalysis",
                name: "lifecycleAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/customerAnalysis/lifecycleAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "客户复购-时间",
                  hasLeft: true,
                },
              },
              // 客户复购-商品标签
              {
                path: "customerRepurchase_itemTag",
                name: "customerRepurchase_itemTag",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/customerAnalysis/customerRepurchaseItemTag.vue",
                  ], resolve);
                },
                meta: {
                  title: "客户复购-商品标签",
                  hasLeft: true,
                },
              },
              // 购买金额分析
              {
                path: "purchaseAmountcleAnalysis",
                name: "purchaseAmountcleAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/customerAnalysis/purchaseAmountcleAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "购买金额分析",
                  hasLeft: true,
                },
              },
              // 购买频次分析
              {
                path: "purchaseCountAnalysis",
                name: "purchaseCountAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/customerAnalysis/purchaseCountAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "购买频次分析",
                  hasLeft: true,
                },
              },
              // 客单价分析
              {
                path: "customerPriceAnalysis",
                name: "customerPriceAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/customerAnalysis/customerPriceAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "客单价分析",
                  hasLeft: true,
                },
              },
              // 复购周期分析
              {
                path: "repurchaseAnalysis",
                name: "repurchaseAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/customerAnalysis/repurchaseAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "复购周期分析",
                  hasLeft: true,
                },
              },
              // 客户生命周期
              {
                path: "customerLifecycle",
                name: "customerLifecycle",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/customerAnalysis/customerLifecycle.vue",
                  ], resolve);
                },
                meta: {
                  title: "客户生命周期",
                  hasLeft: true,
                },
              },
              // 件单价分析
              {
                path: "itemPriceAnalysis",
                name: "itemPriceAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/customerAnalysis/itemPriceAnalysis.vue",
                  ], resolve);
                },
                meta: {
                  title: "件单价分析",
                  hasLeft: true,
                },
              },
              // 留存分析
              {
                path: "retentionAnalysis",
                name: "retentionAnalysis",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/index.vue",
                  ], resolve);
                },
                children: [
                  // 留存分析-店铺
                  {
                    path: "retentionRateAnalysis",
                    name: "retentionRateAnalysis",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/customerAnalysis/retentionRateAnalysis.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "留存分析-店铺",
                      hasLeft: true,
                    },
                  },
                  // 留存分析-商品sku
                  {
                    path: "retentionRateSku",
                    name: "retentionRateSku",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "留存分析-商品sku",
                      hasLeft: true,
                      type: "sku",
                    },
                  },
                  // 留存分析-商品spu
                  {
                    path: "retentionRateSpu",
                    name: "retentionRateSpu",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "留存分析-商品spu",
                      hasLeft: true,
                      type: "spu",
                    },
                  },
                  // 留存分析-平台类目
                  {
                    path: "retentionRateCategory",
                    name: "retentionRateCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "留存分析-平台类目",
                      hasLeft: true,
                      type: "category",
                    },
                  },
                  // 留存分析-店铺类目
                  {
                    path: "retentionRateSellerCategory",
                    name: "retentionRateSellerCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "留存分析-店铺类目",
                      hasLeft: true,
                      type: "sellerCategory",
                    },
                  },
                  // 留存分析-商品标签
                  {
                    path: "retentionRateItemTag",
                    name: "retentionRateItemTag",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "留存分析-商品标签",
                      hasLeft: true,
                      type: "itemTag",
                    },
                  },
                ],
                meta: {
                  title: "留存分析",
                  hasLeft: true,
                },
              },
            ],
            meta: {
              title: "客户分析",
              hasLeft: true,
            },
          },
          //  商品分析
          {
            path: "commodityAnalysis",
            name: "commodityAnalysis",
             component: (resolve) => require(["@/views/prefabricateReport/reviewReport/index.vue"], resolve),
            children: [
              // 商品复购（万能）
              {
                path: "productRepurchase",
                name: "productRepurchase",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/commodityAnalysis/productRepurchase.vue",
                  ], resolve);
                },
                meta: {
                  title: "商品复购（万能）",
                  hasLeft: true,
                },
              },
            ],
            meta: {
              title: "商品分析",
              hasLeft: true,
            },
          },
          // 购买分布
          {
            path: "buyDistribution",
            name: "buyDistribution",
             component: (resolve) => require(["@/views/prefabricateReport/reviewReport/index.vue"], resolve),
            children: [
              // 购买分布-人数
              {
                path: "buyDistribution_PersonNum",
                name: "buyDistribution_PersonNum",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/buyDistribution/buyDistributionCom.vue",
                  ], resolve);
                },
                meta: {
                  title: "购买分布-人数",
                  hasLeft: true,
                  type: 'personNum',
                },
              },
              // 购买分布-件数
              {
                path: "buyDistribution_GoodsNum",
                name: "buyDistribution_GoodsNum",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/buyDistribution/buyDistributionCom.vue",
                  ], resolve);
                },
                meta: {
                  title: "购买分布-件数",
                  hasLeft: true,
                  type: 'goodsNum',
                },
              },
              // 购买分布-计量单位
              {
                path: "buyDistribution_MeasurementUnit",
                name: "buyDistribution_MeasurementUnit",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/buyDistribution/buyDistributionCom.vue",
                  ], resolve);
                },
                meta: {
                  title: "购买分布-计量单位",
                  hasLeft: true,
                  type: 'measurementUnit',
                },
              },
              // 购买分布-购买频次分布
              {
                path: "itemPurchaseCount",
                name: "itemPurchaseCount",
                component: (resolve) => {
                  require([
                    "@/views/prefabricateReport/reviewReport/index.vue",
                  ], resolve);
                },
                children: [
                  // 商品sku购买频次
                  {
                    path: "itemPurchaseCountSku",
                    name: "itemPurchaseCountSku",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "商品sku购买频次",
                      hasLeft: true,
                      type: "sku",
                    },
                  },
                  // 商品spu购买频次
                  {
                    path: "itemPurchaseCountSpu",
                    name: "itemPurchaseCountSpu",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "商品spu购买频次",
                      hasLeft: true,
                      type: "spu",
                    },
                  },
                  // 平台类目购买频次
                  {
                    path: "itemPurchaseCountCategory",
                    name: "itemPurchaseCountCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "平台类目购买频次",
                      hasLeft: true,
                      type: "category",
                    },
                  },
                  // 店铺类目购买频次
                  {
                    path: "itemPurchaseCountSellerCategory",
                    name: "itemPurchaseCountSellerCategory",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "店铺类目购买频次",
                      hasLeft: true,
                      type: "sellerCategory",
                    },
                  },
                  // 商品标签购买频次
                  {
                    path: "itemPurchaseCountItemTag",
                    name: "itemPurchaseCountItemTag",
                    component: (resolve) => {
                      require([
                        "@/views/prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue",
                      ], resolve);
                    },
                    meta: {
                      title: "商品标签购买频次",
                      hasLeft: true,
                      type: "itemTag",
                    },
                  },
                ],
                meta: {
                  title: "购买频次分布",
                  hasLeft: true,
                },
              },
            ],
            meta: {
              title: "购买分布",
              hasLeft: true,
            },
          },
        ],
      },
      // 导入分析
      {
        path: "importReport",
        name: "importReport",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          // 导入订单分析
          {
            path: "tradeImportReport",
            name: "tradeImportReport",
            component: (resolve) => require(["@/views/prefabricateReport/reviewReport/index.vue"], resolve),
            children:[
              {
                path: "tradeImportReportManage",
                name: "tradeImportReportManage",
                component: (resolve) => require(["@/views/prefabricateReport/importAnalysis/importAnalysisOrder.vue"], resolve),
                meta: {
                  title: "导入订单分析",
                  hasLeft: true,
                },
              },
            ],
            meta: {
              title: "导入订单分析",
              hasLeft: true,
            },
          },
          // 自定义人群分析
          {
            path: "tradeCustomReport",
            name: "tradeCustomReport",
            component: (resolve) => require(["@/views/prefabricateReport/importAnalysis/customAudienceAnalysis.vue"], resolve),
            meta: {
              title: "自定义人群分析",
              hasLeft: true,
            },
          },

        ],
        meta: {
          title: "导入分析",
          hasLeft: true,
        },
      },
    ],
  },
  // 后台管理
  {
    path: "/backstageManage",
    name: "backstageManage",
    meta: {
      hasLeft: true,
    },
    // redirect: "/backstageManage/export",
    redirect: "/backstageManage/emptyPage/emptyPage",
    component: (resolve) => require(["@/views/router_page.vue"], resolve),
    children: [
      {
        path: "emptyPage",
        name: "emptyPage",
        redirect: "/backstageManage/emptyPage/emptyPage",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          {
            path: "emptyPage",
            name: "emptyPage",
            component: (resolve) => require(["@/views/prefabricateReport/emptyPage/index.vue"], resolve),
            meta: {
              hasLeft: true,
              routerType: 'backstageManage'
            },
          },
        ],
      },
      // 导出管理
      {
        path: "exportManager",
        name: "exportManager",
        redirect: "/backstageManage/exportManager/export",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          // 导出管理
          {
            path: "export",
            name: "export",
            component: () => import("@/views/backstageManage/exportManager/index.vue"),
            meta: {
              title: "导出管理",
              hasLeft: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/customReport",
    name: "customReport",
    component: (resolve) => require(["../views/router_page.vue"], resolve),
    redirect: "/customReport/customerReportSub",
    children: [
      {
        path: "customerReportSub",
        name: "customerReportSub",
        component: () => import("@/layOuts/index.vue"),
        children: [
          {
            path: "",
            name: "customerReportSub",
            component: () => import("@/views/customReport/index.vue"),
            meta: {
              title: "自定义报表",
              hasLeft: true,
            },
          },
        ],
      },
      {
        path: "myReport",
        name: "myReports",
        component: (resolve) => require(["@/layOuts/index.vue"], resolve),
        children: [
          {
            path: "/customReport/myReport/:id",
            name: "myReport",
            component: () => import("@/views/customReport/myReport.vue"),
            meta: {
              title: "我的自定义报表",
              hasLeft: true,
            },
          },
        ],
      },
      {
        path: "/customReport/createReportTable",
        name: "createReportTable",
        component: () => import("@/views/customReport/create.vue"),
        meta: {
          title: "制作报表",
          hasLeft: false,
        },
      },
    ],
    meta: {
      hasLeft: true,
    },
  },
  {
    path: "/transfer",
    name: "transfer",
    component: (resolve) => require(["../views/router_page.vue"], resolve),
    // component: () => import("@/views/transfer/index.vue"),
    redirect: "/transfer/transfer",
    children: [
      {
        path: "transfer",
        name: "transfer",
        component: () => import("@/layOuts/index.vue"),
        children: [
          {
            path: "",
            name: "transfer",
            component: () => import("@/views/transfer/index.vue"),
            meta: {
              title: "新自定义报表",
              hasLeft: false,
            },
          },
        ],
      }
    ]
  },
  {
    path: "/largeDataScreen",
    name: "largeDataScreen",
    component: () => import("@/views/largeDataScreen/index.vue"),
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/error/403.vue'),
    meta: { title: '403' }
  },
  // 404页面
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/notFound.vue"),
    meta: {
      hasLeft: false,
    },
  },
];

export default routes;
